import React, {Component} from 'react'
import css from './style.css'
import { Link as ScrollLink } from 'react-scroll'
import {connect} from 'react-redux'
import {
  showPrimaryDiamondPanel,
  showMultiStonePanel,
  showMultiStoneHaloPanel,
  showPrimaryDiamondHaloPanel,
  showHaloSideDiamondPanel,
  showProngPanel,
  jewelryTypeIsRing,
  showBailPanel,
  showPendantChainPanel,
  showBasketTypePanel,
  showAdditionalDiamondPanel,
  showBailDiamondPanel,
  showPrimaryMetalTypePanel,
  showStockItemPanel,
  showAdditionalChargePanel
} from '../../utils/jewelry-validation'

class QuestionList extends Component {
  render () {
    const filters = this.props.filters

    const scrollProps = {
      smooth: true,
      offset: -100,
      activeClass: css.active,
      spy: true
    }

    const List = props => (
      <div className={css.list}>
        {props.children}
      </div>
    )

    const ListItem = props => (
      <div className={css.listItem} id={props.id}>
        <Bullet />
        {props.children}
      </div>
    )

    const Bullet = props => (
      <div className={css.bullet} />
    )

    return (
      <List>
        <ScrollLink to='product' {...scrollProps}><ListItem id='product_type_nav'>Product Type</ListItem></ScrollLink>

        {showPrimaryMetalTypePanel(filters) && <ScrollLink to='metaltype' {...scrollProps}><ListItem id='primary_metal_type_nav'>Primary Metal</ListItem></ScrollLink>}

        {showStockItemPanel(filters) && <ScrollLink to='stock_item_description' {...scrollProps}><ListItem id='stock_item_nav'>Item Details</ListItem></ScrollLink>}

        {jewelryTypeIsRing(filters) && <ScrollLink to='ringsize' {...scrollProps}><ListItem id='ring_size_nav'>Ring Size</ListItem></ScrollLink>}

        {showPrimaryDiamondPanel(filters) && <ScrollLink to='diamondshape' {...scrollProps}><ListItem id='primary_diamond_nav_link'>Primary Diamond</ListItem></ScrollLink>}

        {showBasketTypePanel(filters) && <ScrollLink to='basketType' {...scrollProps}><ListItem id='basket_type_nav_link'>Basket Type</ListItem></ScrollLink>}

        {showBailPanel(filters) && <ScrollLink to='bailPanel' {...scrollProps}><ListItem id='bail_nav'>Bail</ListItem></ScrollLink>}

        {showBailDiamondPanel(filters) && <ScrollLink to='bailDiamond' {...scrollProps}><ListItem id='bail_diamond_nav'>Bail Diamonds</ListItem></ScrollLink>}

        {showMultiStonePanel(filters) && <ScrollLink to='multistone' {...scrollProps}><ListItem id='multi_stone_nav'>Multi-Stone</ListItem></ScrollLink>}

        {showMultiStonePanel(filters) && showMultiStoneHaloPanel(filters) && <ScrollLink to='multistonehalo' {...scrollProps}><ListItem id='multi_stone_halo_nav'>Multi-Stone Halo</ListItem></ScrollLink>}

        {showPrimaryDiamondHaloPanel(filters) && <ScrollLink to='centrehalo' {...scrollProps}><ListItem id='centre_halo_nav'>Centre Halo</ListItem></ScrollLink>}

        {showPrimaryDiamondHaloPanel(filters) && showHaloSideDiamondPanel(filters) && <ScrollLink to='halo_side_diamond' {...scrollProps}><ListItem id='halo_side_diamond_nav'>Halo Side Diamonds</ListItem></ScrollLink>}

        {jewelryTypeIsRing(filters) && <ScrollLink to='shank' {...scrollProps}><ListItem id='shank_nav'>Shank</ListItem></ScrollLink>}

        {jewelryTypeIsRing(filters) && <ScrollLink to='shanktop' {...scrollProps}><ListItem id='shank_top_diamond_nav'>Shank Top Diamonds</ListItem></ScrollLink>}

        {jewelryTypeIsRing(filters) && <ScrollLink to='diamonds_on_outside_sides_of_shank' {...scrollProps}><ListItem id='shank_side_diamond_nav'>Shank Side Diamonds</ListItem></ScrollLink>}

        {showProngPanel(filters) && <ScrollLink to='prongStyle' {...scrollProps}><ListItem id='prong_basket_nav'>Prongs & Basket</ListItem></ScrollLink>}

        {showAdditionalDiamondPanel(filters) && <ScrollLink to='additional-diamonds-container' {...scrollProps}><ListItem id='additional_diamonds_nav'>Additional Diamond(s)</ListItem></ScrollLink>}

        {showPendantChainPanel(filters) && <ScrollLink to='hasPendantChain' {...scrollProps}><ListItem id='pendant_chain_nav'>Chain</ListItem></ScrollLink>}

        {showAdditionalChargePanel(filters) && <ScrollLink to='additional_charge_title' {...scrollProps}><ListItem id='additional_options_nav'>Additional Options</ListItem></ScrollLink>}
      </List>
    )
  }
}

function mapStateToProps (state) {
  return {
    filters: state.jewelrySearch.filters
  }
}

export default connect(mapStateToProps)(QuestionList)



// WEBPACK FOOTER //
// ./src/components/question-list/index.js